// extracted by mini-css-extract-plugin
export default {"logomark":"styles__logomark___Fix4L","main":"styles__main___RDh7o","mainInnerWrapper":"styles__mainInnerWrapper___vFIu9"};